//=====================================================
//　G003カレンダー週Body
//=====================================================

import { useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { ReservationType, StatusClass } from "../../utils/ConstCommon";
import { CtxClinicSystemInfo, CtxNewReservation } from "../../utils/Contexts";
import { CtxG003 } from "./G003";

interface IFProps {
    apiData: any,
    refElm: React.RefObject<HTMLDivElement>,
    hoverCellIdx: number,
    setHoverCellIdx: React.Dispatch<React.SetStateAction<number>>,
    resizeWindow: () => void,
}
export function G003CalendarWeeklyBody(props: IFProps){
    const ccsi = useContext(CtxClinicSystemInfo);  //医院情報

    //レンダー後処理
    useEffect(function(){
        props.resizeWindow();
    });

    //セルクリック時の処理
    const uh = useHistory();
    const cnr = useContext(CtxNewReservation);
    const ctx = useContext(CtxG003);
    function clickCell(date: string, time: string, status: number){
        //空き以外のセルの場合は処理中断
        if (status !== 1){
            return false;
        }
        //予約情報を更新して患者情報入力画面へ遷移
        const tmpDate = date.split(" ")[0].split("/");
        let year = ctx.cDate.getFullYear();
        let month = Number(tmpDate[0]) - 1;
        let day = Number(tmpDate[1].slice(0, -4)); //LFと曜日を除去
        let hour = Number(time.split(":")[0]);
        let minutes = Number(time.split(":")[1]);

        if (month === 1 && (ctx.cDate.getMonth() + 1) === 12){
            //選択日が1月　かつ　cDateが12月の場合　はyearを加算する
            year = year + 1;
        }

        cnr.update({date: new Date(year, month, day, hour, minutes, 0)});
        if (cnr.type === ReservationType.First){
            //初診の場合は患者情報入力画面
            uh.push("/reservation/patient");
        }else{
            //初診以外は症状入力画面
            uh.push("/reservation/symptoms");
        }
    
    }

    //APIデータがない場合は処理無し
    if (!props.apiData) {
        return null;
    }

    //APIデータ整形
    const weeklyBodys = getWeeklyBodys(props.apiData);

    //行ループ→列ループでセルを生成する
    //セルはマウスオーバーとアウト時に親のHoverCellIdxを自身のインデックスで更新するよう生成
    return (
        <div className="calendar-body" ref={props.refElm}>
            <table className="calendar">
                <tbody>
                    {weeklyBodys.map(function(rowVal, rowIdx){
                        return (
                            <tr key={rowIdx}>
                                <th>{rowVal.time}</th>
                                {rowVal.cell.map(function(colVal, colIdx){
                                    return (
                                        <td key={colIdx}
                                            onMouseOver={function(){props.setHoverCellIdx(colIdx)}} 
                                            onMouseOut={function(){props.setHoverCellIdx(-1)}} 
                                            className={getCellClass(colVal.status, colIdx, props.hoverCellIdx, ccsi.data.display.phoneIcon)}
                                            onClick={function(){clickCell(colVal.date, rowVal.time, colVal.status)}}>
                                        </td>
                                    )
                                })}
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </div>
    )
   
}

//-----------------------------------------------------
//　APIデータ整形
//-----------------------------------------------------
interface IFWeeklyBodys {
    time: string,
    cell: [{
        date: string,
        status: number,
    }]
}
function getWeeklyBodys(apiData:any):IFWeeklyBodys[]{

    let weeklyBodys:IFWeeklyBodys[] = [];

    //テーブルに出力するため、日付ごとのデータを時間ごとのデータに整形
    //日付ループ
    let dayCnt = 0;
    apiData.frames.forEach(function(dayVal:any){

        //時間ループ
        let timeCnt = 0;
        dayVal.frames.forEach(function(timeVal:any){
            
            if (dayCnt === 0){
                //1日目
                weeklyBodys.push({time: timeVal.time, cell: [{date: dayVal.date, status: getWeeklyStatus(timeVal.status)}]});
            } else {
                //それ以降
                weeklyBodys[timeCnt].cell.push({date: dayVal.date, status: getWeeklyStatus(timeVal.status)});            
            }
            timeCnt = timeCnt + 1;

        });
        
        dayCnt = dayCnt + 1;

    });

    return weeklyBodys;

}

//-----------------------------------------------------
//　セルのクラス取得
//-----------------------------------------------------
function getCellClass(status: number, myCellIdx:number, hoverCellIdx: number, phoneIcon: boolean){

    let cellClass = "";

    //ステータス
    if (status === 1){
        cellClass = "is-active is-vacant";
    // } else if (phoneIcon && status === 4) {
    //     cellClass = "is-reserve-phone";
    }

    //hover時スタイル
    if (hoverCellIdx === myCellIdx) {
        cellClass = cellClass + " is-hover";
    }

    return cellClass;

}

//-----------------------------------------------------
//　週用ステータスの整形
//-----------------------------------------------------
function getWeeklyStatus(val:any):number{

    const tmpVal = Number(val);
    let tmpStatus = StatusClass["is-no-vacant"];

    switch (tmpVal){
        // case 4:
        //     tmpStatus = StatusClass["is-reserve-phone"];
        //     break;
        case 1:
        case 2:
            tmpStatus = StatusClass["is-vacant"];
            break;
    }

    return tmpStatus;

}